<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M11.7923 0.208646C11.9137 0.318641 11.9932 0.473399 11.9932 0.650316L12 5.65391C12 5.98499 11.7339 6.25318 11.4042 6.25262C11.0876 6.25208 10.8199 5.9824 10.5575 5.71812C10.5471 5.70765 10.5368 5.6972 10.5264 5.68676L9.26781 4.42127L2.03097 11.6665C1.58849 12.1105 0.869647 12.1113 0.426234 11.6682L0.332368 11.5744C-0.111825 11.1306 -0.110634 10.4103 0.335023 9.96795L7.58989 2.73395L6.33131 1.46845C6.32587 1.463 6.32019 1.45731 6.31429 1.45141C6.14129 1.27833 5.78203 0.918907 5.78148 0.598711C5.78148 0.267598 6.04817 -0.000591452 6.3773 2.27919e-08L11.3531 0.00681465C11.529 0.00737752 11.6828 0.0867414 11.7923 0.208646Z"
    fill="currentColor"
  />
</template>
